import React from 'react';
import { Quote } from 'lucide-react';

const TESTIMONIALS = [
  {
    quote: 'ELEVA shipped in three weeks what our previous agency couldn\'t in nine months. The work speaks for itself.',
    author: 'Priya Anand',
    role: 'COO, Helios Capital',
    image: 'https://images.pexels.com/photos/12396627/pexels-photo-12396627.jpeg',
  },
  {
    quote: 'They don\'t just build — they think. Every recommendation had a business case attached. Rare.',
    author: 'Marcus Devlin',
    role: 'Founder, Northwind Logistics',
    image: 'https://images.pexels.com/photos/17685845/pexels-photo-17685845.jpeg',
  },
  {
    quote: 'The AI workflow they architected paid for itself in the first quarter. Now we\'re scaling it across the company.',
    author: 'Sara Okonkwo',
    role: 'VP Product, Lume',
    image: 'https://images.pexels.com/photos/12396627/pexels-photo-12396627.jpeg',
  },
  {
    quote: 'Senior thinking, modern execution, zero bureaucracy. Exactly what we needed.',
    author: 'David Chen',
    role: 'CTO, Atlas Brands',
    image: 'https://images.pexels.com/photos/17685845/pexels-photo-17685845.jpeg',
  },
];

const Card = ({ t, index }) => (
  <div
    data-testid={`testimonial-card-${index}`}
    className="shrink-0 w-[340px] md:w-[440px] bg-brand-surface border border-white/10 p-8 flex flex-col gap-6 mx-3"
  >
    <Quote size={28} className="text-brand-primary" />
    <p className="font-manrope text-base lg:text-lg text-white/85 leading-relaxed">
      &ldquo;{t.quote}&rdquo;
    </p>
    <div className="mt-auto flex items-center gap-3 pt-4 border-t border-white/10">
      <img src={t.image} alt={t.author} className="w-10 h-10 object-cover grayscale" loading="lazy" />
      <div>
        <div className="font-outfit font-semibold text-white text-sm">{t.author}</div>
        <div className="font-manrope text-xs text-white/50">{t.role}</div>
      </div>
    </div>
  </div>
);

export const Testimonials = () => {
  const items = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 lg:py-40 border-t border-white/10 overflow-hidden">
      {/* Outline backdrop text */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <span className="font-outfit font-black text-[18vw] lg:text-[14vw] outline-text tracking-tighter whitespace-nowrap">
          WHAT THEY SAY
        </span>
      </div>

      <div className="relative">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-1.5 h-1.5 bg-brand-primary" />
            <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
              05 — Clients
            </span>
          </div>
        </div>

        <div className="relative w-full overflow-hidden">
          <div className="flex animate-marquee w-max">
            {items.map((t, i) => (
              <Card key={i} t={t} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
